import $ from 'jquery';

export default function Category(vm) {
    this.all = function(params) {
        var url = '/category/list?' + $.param(params);

        return vm.get(url);
    };
}